// extracted by mini-css-extract-plugin
export var lbContainerOuter = "x_t2";
export var lbContainerInner = "x_t3";
export var movingForwards = "x_t4";
export var movingForwardsOther = "x_t5";
export var movingBackwards = "x_t6";
export var movingBackwardsOther = "x_t7";
export var lbImage = "x_t8";
export var lbOtherImage = "x_t9";
export var prevButton = "x_vb";
export var nextButton = "x_vc";
export var closing = "x_vd";
export var appear = "x_vf";